'use client'

import {ReactNode, useState} from 'react'
import {cx} from '@local/utils/cx'
import {Modal, Button, NewsletterForm} from '@local/ui/components'
import CrossSvg from '@local/assets/svgs/icon-close.svg'
import {useIsomorphicLayoutEffect, useSession} from '@local/hooks'
import {PortableTextBlock} from '@portabletext/types'
import {usePathname} from 'next/navigation'

export interface NewsletterPopUpContentProps {
	containerClassName?: string;
	className?: string;
	newsletter: {
		successMessage: string;
		terms: PortableTextBlock[];
		listID: string;
	};
	landingCTA: {
		image: any;
		surtitle: string;
		title: string;
		text: string;
		cta: {
			label: string;
			link: string;
		};
	};

	children: ReactNode;
}

const NEWSLETTER_POPUP_SHOWN = 'notShown'

export const NewsletterPopUpContent = ({
	containerClassName,
	landingCTA,
	newsletter,
	children,
}: NewsletterPopUpContentProps) => {
	const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false)
	const [isLandingPopupOpen, setIsLandingPopupOpen] = useState<boolean>(false)
	const pathname = usePathname()
	const isLandingPage = pathname.includes('/landing/')

	const [newsletterPopUpShown, setNewsletterPopUpShown] = useSession<string>(
		'newsletterPopUpShown',
		NEWSLETTER_POPUP_SHOWN,
	)

	const handleSuccess = () => {
		setNewsletterPopUpShown('shown')
		setIsLandingPopupOpen(true)
	}

	useIsomorphicLayoutEffect(() => {
		let timeout
		if (isLandingPage) return
		if (newsletterPopUpShown === 'notShown') {
			timeout = setTimeout(() => {
				setIsPopupOpen(true)
			}, 45000)
		}
		return () => {
			clearTimeout(timeout)
		}
	}, [])

	const closeNewsletterPopUp = () => {
		setIsPopupOpen(false)
		setNewsletterPopUpShown('shown')
	}
	return (
		<>
			<Modal
				isActive={isPopupOpen}
				onClickClose={() => setIsPopupOpen(false)}
				className={cx('w-full bottom-0', containerClassName)}>
				<Button
					type='button'
					variant='secondary-icon'
					small
					onClick={closeNewsletterPopUp}
					className={cx(
						'absolute top-10 right-10 z-2 text-black aspect-square px-0 border-black',
						'lg:top-20 right-20',
					)}>
					<CrossSvg />
				</Button>
				{children}

				{isLandingPopupOpen
					? (
						<div className='py-4 px-10'>
							{landingCTA.cta && (
								<div className='py-10 flex-1  px-20'>
									<Button
										onClick={closeNewsletterPopUp}
										linkInput={landingCTA.cta}
										variant='primary'
										className='text-12 w-full mx-auto hover:border hover:border-black'>
										{landingCTA.cta.label}
									</Button>
								</div>
							)}
							<p className='text-12 lg:text-16 leading-moderate tracking-snug px-20 pb-10 text-center text-grey-2'>
								{newsletter.successMessage}
							</p>
						</div>
					)
					: (
						<NewsletterForm
							className='margin-px-1 lg:col-start-2 lg:w-full lg:pb-20'
							formClassName='!w-full'
							successMessage={newsletter.successMessage}
							terms={newsletter.terms}
							hasSurtitle={false}
							listID={newsletter.listID}
							onSuccess={handleSuccess}
							textColor='text-black'
							successClassName='hidden' />
					)}
			</Modal>
		</>
	)
}
